@if(order) {
<mat-card [ngClass]="{'!surface-neutral': selected}">
  <div class="tw-flex tw-flex-col tw-gap-1 tw-cursor-pointer tw-p-2">
    @if(order.UserProfile ) {
    <div class="tw-font-semibold">{{order.UserProfile?.Name}}</div>
    }
    <div class="tw-flex tw-flex-wrap tw-gap-1 tw-items-center tw-justify-between">
      <div>{{(order.CompletedTime || order.RegisterTime)|date: 'short'}}</div>
      <div class="tw-font-semibold">#{{order.SequenceNo || order.Number}}</div>
    </div>
    <div class="tw-flex tw-flex-wrap tw-gap-1 tw-items-center tw-justify-between">
      <div class="tw-flex tw-gap-1 tw-items-center">
        <div class="uw-tag uw-neutral">{{order.Source}}</div>
        <div class="uw-tag uw-secondary">{{order.Type}}</div>
      </div>
      @if(order.Type=='Delivery' && order.Location?.Postcode){<span>({{order.Location?.Postcode}})</span>}
    </div>
    <div class="tw-flex tw-flex-wrap tw-gap-1 tw-items-center tw-justify-between">
      <div class="tw-flex tw-gap-1 tw-items-center">
        @if(order.Status != 'Pending') {
        <div class="uw-tag uw-tertiary">{{order.Status}}</div>
        }
        @if(order.Payment) {
          
          @if(order.Payment.Status == 'Success') {
            <div class="uw-tag uw-success">Paid</div>
            <div class="uw-tag uw-neutral">{{order.Payment.PaymentMethod || (order.Payment.IsCash ? 'Cash' : 'Not specified')}}</div>
        } @else {
        <div class="uw-tag uw-danger">Unpaid</div>
        }
        }
      </div>
      <div class="tw-font-semibold tw-ms-auto">{{order.PayableAmount|currency:'&pound;'}}</div>
    </div>
  </div>
</mat-card>

}